// ******************** SET PORTAL AVAILABILITY ********************
export const SET_PORTAL_AVAILABILITY = 'SET_PORTAL_AVAILABILITY';

// ******************** SET INTERNAL SERVER ERROR ********************
export const SET_INTERNAL_SERVER_ERROR = 'SET_INTERNAL_SERVER_ERROR';
